import type {BuyingOption, BuyingOptionsSortOption, Product, SortingOption} from '../types'

export const AMAZON_DOMAINS_BY_LOCALE: Record<string, string> = {
  US: 'www.amazon.com',
  UK: 'www.amazon.co.uk',
  CA: 'www.amazon.ca',
  DE: 'www.amazon.de',
  IN: 'www.amazon.in',
  FR: 'www.amazon.fr',
  IT: 'www.amazon.it',
  ES: 'www.amazon.es',
  AU: 'www.amazon.com.au',
}

const sorters: Record<SortingOption, (_products: Product[]) => Product[]> = {
  editorsChoice: (products) => products,
  discount: (products) => {
    return [...products].sort((a, b) => {
      const aDiscount = Number(a.discount ?? 0)
      const bDiscount = Number(b.discount ?? 0)
      return bDiscount - aDiscount
    })
  },
  priceAsc: (products) => {
    return [...products].sort((a, b) => {
      const aPrice = Number(a?.price?.amount ?? 0)
      const bPrice = Number(b?.price?.amount ?? 0)
      return aPrice - bPrice
    })
  },
}

export const getSortedProducts = (products: Product[], sortingType: SortingOption | null) => {
  if (!sortingType || sortingType.length === 0) return products
  const sort = sorters[sortingType] ?? sorters['editorsChoice']
  return sort(products)
}

export function asinToUrl(asin: string, locale: string) {
  return `https://${AMAZON_DOMAINS_BY_LOCALE[locale.toUpperCase()] ?? AMAZON_DOMAINS_BY_LOCALE.US}/dp/${asin}`
}

export const sortBuyingOptions = (options: BuyingOption[], sortBy: BuyingOptionsSortOption | null): BuyingOption[] => {
  if (!sortBy || sortBy === 'recommended') {
    return options
  }

  if (sortBy === 'price') {
    return [...options].sort((a, b) => {
      return a.price - b.price
    })
  }

  return options
}
